/* Enhance current Shopify policy content; no duplicated policy terms. */
if (!customElements.get('mas-care-policy')) {
  let careInstance = 0;
  customElements.define('mas-care-policy', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.careReady) return;
      const source = this.querySelector('[data-care-source]');
      if (!source) return;
      this.dataset.careReady = 'true';
      const shipping = this.dataset.careKind === 'shipping';
      const page = this.closest('.mas-care--editorial');
      const prefix = 'care-' + (++careInstance);
      const deadline = !shipping && Array.from(source.querySelectorAll('b,strong')).find(el => /contact us within .*delivery/i.test(el.textContent));
      if (deadline) {
        const notice = document.createElement('p');
        notice.dataset.careNotice = '';
        notice.textContent = deadline.textContent.trim();
        this.insertBefore(notice, this.firstChild);
        const deadlineCopy = page && page.querySelector('[data-care-deadline-copy]');
        if (deadlineCopy) {
          deadlineCopy.textContent = deadline.textContent.trim();
          deadlineCopy.closest('[data-care-deadline-summary]').hidden = false;
        }
      }
      source.querySelectorAll('[style],[class]').forEach(el => { el.removeAttribute('style'); el.removeAttribute('class'); });
      if (shipping && page) {
        const restriction = Array.from(source.querySelectorAll('p')).find(el => /cannot ship live/i.test(el.textContent));
        const restrictionCopy = page.querySelector('[data-care-restrictions-copy]');
        if (restriction && restrictionCopy) {
          restrictionCopy.append(restriction.cloneNode(true));
          restrictionCopy.closest('[data-care-restrictions]').hidden = false;
        }
      }
      const nodes = Array.from(source.childNodes);
      const groups = [{ title: shipping ? 'Aquarium shipping overview' : 'Live Arrival Guarantee overview', nodes: [], intro: true }];
      let group = groups[0];
      for (const node of nodes) {
        if (node.nodeType !== 1) { group.nodes.push(node); continue; }
        const text = node.textContent.trim();
        if (shipping && /^Shipping Policy\s*[—–-]/i.test(text)) continue;
        const lead = node.firstElementChild;
        const startsStrong = node.tagName === 'P' && lead && /^(STRONG|B)$/.test(lead.tagName) && !node.textContent.trimStart().indexOf(lead.textContent.trim());
        const title = startsStrong ? lead.textContent.trim() : /^H[12]$/.test(node.tagName) ? text : '';
        const isSubheading = /^\d+\. (Express|Toll)/.test(title);
        const isHeading = title && !isSubheading && !/^💬|^Please note/i.test(title);
        if (isHeading) {
          group = { title: title.replace(/^\d+\.\s*/, ''), nodes: [] };
          groups.push(group);
          if (startsStrong) {
            lead.remove();
            while (node.firstChild && (node.firstChild.nodeName === 'BR' || !node.firstChild.textContent.trim())) node.firstChild.remove();
            if (node.textContent.trim()) group.nodes.push(node);
          }
        } else {
          if (shipping && /cannot ship live/i.test(text)) node.dataset.careNotice = '';
          if (isSubheading) {const heading=document.createElement('h3');heading.textContent=title;group.nodes.push(heading);}
          else group.nodes.push(node);
        }
      }
      if (groups.length < 2) return;
      const fragment=document.createDocumentFragment();
      const links=[];
      groups.forEach((entry,index)=>{
        if (!entry.nodes.some(n=>n.textContent.trim())) return;
        const details=document.createElement('details');
        details.id=prefix+'-'+index;
        const summary=document.createElement('summary');
        const heading=document.createElement('h2');
        heading.textContent=entry.title;
        summary.append(heading);
        const body=document.createElement('div');body.dataset.careSectionBody='';body.append(...entry.nodes);
        details.append(summary,body);
        const key = entry.title.toLowerCase();
        details.dataset.careTopic = key;
        if (shipping && /shipping options|shipping schedule/.test(key) || !shipping && /our live arrival|something arrives|how we resolve/.test(key)) details.open=true;
        let shortcut='';
        if(shipping){if(/shipping options/.test(key))shortcut='Delivery & rates';else if(/how we pack/.test(key))shortcut='Packing';else if(/local pickup/.test(key))shortcut='Local pickup';}
        else {if(/something arrives/.test(key))shortcut='DOA & missing items';else if(/how we resolve/.test(key))shortcut='Refunds & store credit';else if(/conditions/.test(key))shortcut='Conditions';}
        if(shortcut){const a=document.createElement('a');a.href='#'+details.id;a.textContent=shortcut;a.addEventListener('click',e=>{e.preventDefault();details.open=true;details.scrollIntoView({block:'start',behavior:'auto'});summary.focus({preventScroll:true});});links.push(a);}
        fragment.append(details);
      });
      source.replaceChildren(fragment);
      const topics=this.querySelector('[data-care-topics]');
      if(topics && links.length){topics.replaceChildren(...links);topics.hidden=false;}
      if (page) {
        const reportSteps = page.querySelectorAll('.mas-care__report-steps details');
        if (window.matchMedia('(max-width: 749px)').matches) reportSteps.forEach(step => { step.open = false; });
        const fullPolicy = page.querySelector('.mas-care__full-policy');
        const reveal = (target) => {
          fullPolicy.open = true;
          if (target.tagName === 'DETAILS') target.open = true;
          target.scrollIntoView({ block: 'start', behavior: 'auto' });
          (target.querySelector('summary') || target).focus({ preventScroll: true });
        };
        page.querySelectorAll('[data-care-target],[data-care-open-policy]').forEach(link => {
          const topic = link.dataset.careTarget;
          const target = topic && Array.from(source.querySelectorAll('details')).find(detail => detail.dataset.careTopic.includes(topic)) || fullPolicy;
          link.href = '#' + target.id;
          link.addEventListener('click', event => { event.preventDefault(); reveal(target); });
        });
        const hashTarget = Array.from(source.querySelectorAll('details')).find(detail => '#' + detail.id === location.hash);
        if (hashTarget || location.hash === '#' + fullPolicy.id) reveal(hashTarget || fullPolicy);
      }
      this.addEventListener('click',event=>{
        const link=event.target.closest('a[href]');if(!link)return;
        const info=this.closest('mas-ksp-info');if(!info)return;
        let url;try{url=new URL(link.getAttribute('href'),location.origin);}catch{return;}
        const sameShop=url.origin===location.origin || ['microaquaticshop.com.au','www.microaquaticshop.com.au','helloofish.myshopify.com'].includes(url.hostname);
        if(!sameShop)return;
        const panel=/\/(pages|policies)\/shipping-policy$/.test(url.pathname)?'packing':/\/pages\/guarantee$|\/blogs\/beginners-guide\/doa-and-missing-items-policy$/.test(url.pathname)?'guarantee':null;
        if(panel){event.preventDefault();info.openPanel(panel,info.returnFocus);}
      });
    }
  });
}
